// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"GYRfnP","container":"OUarm8"};